import React, { useState, useEffect } from 'react'
import "./sideItem.css"
import { Link, NavLink, useLocation } from 'react-router-dom'


const SideItem = ({ title, children, path }) => {
    const [activeLink, setActiveLink] = useState(false)
    const [activeChild, setActiveChild] = useState(1)
    // let location = useLocation();
    // useEffect(() => {

    //     location.pathname === '/details' && setActiveLink(true)
    // }, [location.pathname])
    return (
        <div className="side_item"  >
            <span></span>
            <span></span>

            <NavLink to={`${path}`}
                onClick={() => setActiveChild(1)}
                style={({ isActive }) => {
                    isActive ? setActiveLink(true) : setActiveLink(false)
                    // return { width: "100%" }
                }}
            >
                {/* <Typography.Title level={5} >{title}</Typography.Title> */}
                <h5 className="title">{title}</h5>
            </NavLink>
            {
                activeLink && <div className='children'>
                    {children && children.map((v, i) => {
                        return (
                            <Link key={i} to={v.path} onClick={() => setActiveChild(i + 1)}  >
                                <h6 style={{ color: activeChild === v.id ? "var(--color-blue)" : "var(--color-gray)" }}>{v.title}</h6>
                            </Link>
                        )
                    })}

                </div>
            }
        </div >
    )
}

export default SideItem